// extracted by mini-css-extract-plugin
export var loadingShimmer = "_ro-2";
export var messageContent = "_ro-0";
export var messagesScroll = "_ro-1";
export var shimmer = "_ro-3";
export var shimmerW100 = "_ro-4";
export var shimmerW70 = "_ro-8";
export var shimmerW80 = "_ro-7";
export var shimmerW85 = "_ro-6";
export var shimmerW90 = "_ro-5";